import { useState, memo } from "react";
import clsx from "clsx";
import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { palette } from "../../../theme/palette";
import { View } from "../../View";
import { RouteLabel } from "./RouteLabel";
import { PickupVolumes } from "./PickupVolumes";

const useStyles = makeStyles({
  markerContainer: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "2px",
    cursor: "pointer",
  },
  container: {
    maxWidth: "86px",
    minWidth: "30px",
    minHeight: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "center",
  },
  arrow: {
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "10px solid white",
  },
  space: {
    width: "10px",
  },
  spacing: {
    padding: "2px",
  },
});

export const PickupMarkerLabel = memo(
  ({ postcode, pickupConfig, handlePickupModalChange }) => {
    const [shouldShowPopupOnClick, setShouldShowPopupOnClick] = useState(true);
    const styles = useStyles();

    const { routeCodes, popupLabels } = pickupConfig;

    return (
      <View
        className={styles.markerContainer}
        onClick={() => {
          if (!Object.keys(popupLabels).length) return;
          handlePickupModalChange(shouldShowPopupOnClick, {
            postcode,
            onClose: () => setShouldShowPopupOnClick(true),
          });
          setShouldShowPopupOnClick(!shouldShowPopupOnClick);
        }}
      >
        <View>
          <Grid container className={styles.container}>
            {routeCodes.length > 6 ? (
              <Grid
                item
                container
                xs
                className={clsx(styles.spacing)}
                direction={"row"}
              >
                <RouteLabel routeCode={"M"} />
              </Grid>
            ) : (
              routeCodes.map((routeCode, index) => (
                <Grid
                  key={index}
                  item
                  container
                  xs={routeCodes.length >= 3 ? 4 : 12 / routeCodes.length}
                  className={clsx(styles.spacing)}
                  direction={"row"}
                >
                  <RouteLabel routeCode={routeCode} />
                  <PickupVolumes
                    postcode={postcode}
                    pickupConfig={pickupConfig}
                  />
                </Grid>
              ))
            )}
          </Grid>
        </View>
        <View className={styles.arrowContainer}>
          <View className={styles.arrow} />
        </View>
      </View>
    );
  }
);
